var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [!_vm.$vuetify.breakpoint.mobile && _vm.ready ? _c('main-slide', _vm._g({
    attrs: {
      "banners": _vm.pcBanners
    }
  }, {
    open: _vm.open
  })) : _vm._e(), _vm.$vuetify.breakpoint.mobile && _vm.ready ? _c('main-mobile-slide', _vm._g({
    attrs: {
      "banners": _vm.mobileBanners
    }
  }, {
    open: _vm.open
  })) : _vm._e(), _c('v-container', {
    staticClass: "px-0 px-lg-12px"
  }, [_c('main-profile'), _c('main-button-group')], 1), _c('section', {
    staticClass: "main-section best-seller"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("베스트 셀러")])]), _c('product-list', {
    staticClass: "main-product-list",
    attrs: {
      "skin": "main",
      "is-main": "",
      "category-code": "bestseller",
      "limit": "8"
    }
  })], 1)], 1), _c('main-book-of-the-month'), _c('section', {
    staticClass: "main-section",
    staticStyle: {
      "background-color": "#f9f9f9"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("교환 가능 상품")])]), _c('partners-slide')], 1)], 1)], 1), _c('popup-layer', {
    attrs: {
      "code": "main"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }